module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-11.a33c8abb.png";